import { computed, unref, type MaybeRef } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import type { AxiosResponse } from 'axios';
import type { specialOffers } from 'shared';

import { mapOffersResults } from '@/shared/lib';
import { api } from '@/shared/api';

export function getSpecialOfferDetail({
  id,
  depCityCode,
}: {
  id: MaybeRef<string>;
  depCityCode: MaybeRef<string>;
}) {
  return {
    queryKey: ['special-offers', 'offers', id, depCityCode],
    queryFn: () =>
      api.specialOffers.offers({ id: unref(id), depCity: unref(depCityCode) }),
    staleTime: 3 * 60 * 1000,
  };
}

export function useSpecialOfferDetail({
  id,
  depCityCode,
}: {
  id: MaybeRef<string>;
  depCityCode: MaybeRef<string>;
}) {
  const query = useQuery<AxiosResponse<specialOffers.SpecialOffer[]>>(
    getSpecialOfferDetail({ id, depCityCode }),
  );

  const offers = computed(() =>
    (query.data.value?.data ?? []).map(mapOffersResults),
  );
  const isLoading = computed(() => query.isLoading.value);

  return { offers, isLoading };
}
